export const space = {
  pad: "clamp(16px, 4vw, 40px)",
  gap: "clamp(20px, 3vw, 32px)",
  sec: "clamp(72px, 10vw, 160px)",
  head: "clamp(40px, 6vw, 80px)",
};

export const sizes = {
  maxw: "1440px",
};

export const radii = {
  sm: "8px",
  md: "12px",
  lg: "20px",
};

export const transition = {
  easing: {
    brand: "cubic-bezier(0.22, 1, 0.36, 1)",
  },
};
